import { RegentsExportTransferCtrl } from './regents-export-transfer.controller';

export const RegentsExportStepTransferComponent = {
  controller: RegentsExportTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./regents-export-transfer.html'),
};
